// src/app/utils/dom-utils.ts

import { ElementRef } from '@angular/core';

/**
 * Scroll the given container element to the bottom
 * @param container ElementRef of the scrollable container
 */
export function scrollToBottom(container: ElementRef<HTMLElement>) {
  if (container) {
    setTimeout(() => {
      const el = container.nativeElement;
      el.scrollTop = el.scrollHeight;
    }, 0); // Use setTimeout to ensure DOM updates are complete
  }
}
